export default __webpack_public_path__ + "static/media/minimp3.a592adb6.png";